import { useRef, useState } from 'react';

import PropTypes from 'prop-types';

import SearchIcon from '@mui/icons-material/Search';
import { Box, InputBase, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const StyledInput = styled(InputBase)(({ theme }) => ({
  '&': {
    width: '100%',
  },
  '& .MuiInputBase-input': {
    borderRadius: '20px',
    position: 'relative',
    backgroundColor: '#F1F1F1',
    fontSize: 28,
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    textAlign: 'center',
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const DeliverySearchComponent = (props) => {
  const { value, onChange } = props;

  const inputEl = useRef(null);

  const [isPlaceholderShown, setIsPlaceholderShown] = useState(true);

  const onPlaceholderClick = () => {
    setIsPlaceholderShown(false);
    inputEl.current.focus();
  };

  return (
    <Box position="relative">
      <StyledInput
        value={value}
        onChange={onChange}
        inputRef={inputEl}
        onBlur={() => !value && setIsPlaceholderShown(true)}
        onFocus={() => setIsPlaceholderShown(false)}
      />
      {isPlaceholderShown && (
        <Box
          width="100%"
          height="100%"
          className="center-content"
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap="1rem"
          onClick={onPlaceholderClick}
        >
          <SearchIcon fontSize="large" />
          <Typography
            color="#333"
            textAlign="center"
            sx={{ fontSize: { xs: 22, sm: 28 } }}
          >
            Search deliveries by unit
          </Typography>
        </Box>
      )}
    </Box>
  );
};

DeliverySearchComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default DeliverySearchComponent;
